import React from 'react';

const TranslationsContext = React.createContext({
    language: 'es',
    setLanguage: (_: string) => {},
});

export default TranslationsContext;